import { InjectionToken } from '@angular/core';

export interface NgrxJwtStateConfigInterface {
  jwtCookieName: string;
  expiryCookieName: string;
  appEnvFqdn: string;
}

export const NGRX_JWT_STATE_CONFIG = new InjectionToken<NgrxJwtStateConfigInterface>('NGRX JwtReducer configuration', {
  providedIn: 'root',
  factory: () => ({
    jwtCookieName: undefined as any,
    expiryCookieName: undefined as any,
    appEnvFqdn: undefined as any,
  }),
});
